// extracted by mini-css-extract-plugin
module.exports = {"ItemTabs":"ItemTabs_ItemTabs__o8diR"};